import css from 'styled-jsx/css'

import { colors, sizes } from '../../theme'
import common from '../../theme/common'


export default css`
    .swiper :global(.button-prev),
    .swiper :global(.button-next) {
        position: relative;
        cursor: pointer;
        z-index: 1;
        background-color: transparent;
        margin-top: 2rem;
    }

    .swiper .swiper-button-disabled {
        opacity: .3;
        pointer-events: none;
    }

    .swiper .arrows {
        text-align: right;
    }

    .swiper :global(.button-prev) {
        top: 100%;
        left: 0;
        margin-right: 3rem;
    }

    .swiper :global(.button-next) {
        top: 100%;
        left: 0;
    }

    .swiper :global(.button-prev img),
    .swiper :global(.button-next img) {
        width: 3.5rem;
    }

    @media screen and (max-width: ${sizes.media.tablet.maxWidth}) {
        .swiper :global(.button-prev),
        .swiper :global(.button-next) {
            position: relative;
            margin-top: 3rem;
        }

        .swiper :global(.button-prev) {
            margin-right: 2.5rem;
        }

        .swiper :global(.button-prev img),
        .swiper :global(.button-next img) {
            width: 2.2rem;
        }
    }
`
